export default [
	{
		type: 'CPO',
		selector: '.badge-callout a.certified, .badge-callout .certified a'
	},
	{
		type: 'Maintain the Love',
		selector: 'a.mtl-badge, .mtl-badge a'
	},
	{
		type: 'CR Trust Mark',
		selector: 'a.trustmark-link, .trustmark-link a'
	},
	{
		events: 'scheduleServiceClick',
		type: 'Schedule Service',
		selector: [
			'.schedule-service.include-velocity a',
			'.page-header .cst_SCHEDULE_SERVICE a',
			'a[data-location="page-schedule-service-button"]',
			'a[href*="/ServiceApptForm.htm"]',
			'a[href*="/schedule-service.htm"]',
			'a[href*="/service/index.htm"]',
			'a[href*="/service/center.htm"]',
			'a[href*="/service/scheduler.htm"]',
			'a[href*="/service/schedule-service.htm"]',
			'a[href*="/eleads-service-scheduler-mobile.htm"]',
			'a[href*="/e-leads-service-scheduler.htm"]',
			'a[href*="/schedule-service-online.htm"]',
			'a[href*="/service/schedule-appointment.htm"]',
			'a[href*="/schedule-your-service-appointment.htm"]',
			'a[href*="/service-scheduler.htm"]',
			'a[href*="/schedule_service.htm"]'
		]
	}
];
